import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'

import { AvailabilityPickerModule } from '../availability-picker'
import { AppointmentWaitlistDialogComponent } from './appointment-waitlist-dialog.component'

@NgModule({
  imports: [
    AvailabilityPickerModule,
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    AppointmentWaitlistDialogComponent,
  ],
  declarations: [
    AppointmentWaitlistDialogComponent,
  ],
  providers: [],
})
export class AppointmentWaitlistDialogModule { }
